/**
 * Custom hook to access Flight and Hotel bundle data from Redux store
 */

import { useCallback } from 'react'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'
import {
  updateFlightData,
  updateSelectedDates,
  resetBundle
} from 'actions/FlightAndHotelBundleActions'

export function useFlightAndHotelBundle() {
  const bundleData = useAppSelector(state => state.flightAndHotelBundle)
  const dispatch = useAppDispatch()

  // Stabilize action methods with useCallback
  const updateFlightDataCallback = useCallback(
    (payload: Parameters<typeof updateFlightData>[0]) => dispatch(updateFlightData(payload)),
    [dispatch]
  )

  const updateSelectedDatesCallback = useCallback(
    (payload: Parameters<typeof updateSelectedDates>[0]) => dispatch(updateSelectedDates(payload)),
    [dispatch]
  )

  const resetBundleCallback = useCallback(
    () => dispatch(resetBundle()),
    [dispatch]
  )

  return {
    // State
    ...bundleData,
    // Actions (stabilized with useCallback)
    updateFlightData: updateFlightDataCallback,
    updateSelectedDates: updateSelectedDatesCallback,
    resetBundle: resetBundleCallback,
  }
}

export default useFlightAndHotelBundle
